module.exports = __webpack_public_path__ + "img/sankaku_22_red.af5e8b72.png";